import { z } from 'zod';
import { appFieldsFileSchema, appScreensFileSchema, fautesDeTitre } from '@taki/data-model';

/** Contrat pur du document d'instance, commun au SDK et au relais IA. */
export const INSTANCE_SCHEMA_VERSION = 1;

export const ficheInstancieeSchema = z.object({
  name: z.string().trim().min(1).max(80).optional(),
  description: z.string().trim().min(1).max(500).optional(),
  icon: z.string().trim().min(1).max(80).optional(),
  menu: z.object({ label: z.string().trim().min(1).max(40).optional() }).strict().optional(),
}).strict();

export const declarationSchema = z.object({
  champs: appFieldsFileSchema,
  ecrans: appScreensFileSchema,
  fiche: ficheInstancieeSchema.optional(),
}).strict();

export const modeleSchema = declarationSchema.extend({ version: z.string().trim().min(1) });

/**
 * L'instance TELLE QU'ELLE SE LIT : forme seule, sans jugement. Une instance
 * ecrite avant une regle doit continuer de se relire (le journal, le garde
 * « instance en protocole », la capture des orgs).
 */
export const instancePayloadLectureSchema = z.object({ modele: modeleSchema }).merge(declarationSchema).strict();

/**
 * L'instance TELLE QU'ELLE S'ECRIT : la forme, puis le titre d'une fiche, qui
 * est un texte et jamais un lien ni un choix brut (`fautesDeTitre`, data-model).
 * C'est la DECLARATION de l'instance qui est jugee, jamais le cliche `modele`,
 * qui peut etre ancien en base. Le jugement est un `superRefine` pose APRES le
 * `.merge` et le `.strict()` : il ne casse aucun `.extend` ni `.merge`.
 */
export const instancePayloadSchema = instancePayloadLectureSchema.superRefine((instance, ctx) => {
  for (const faute of fautesDeTitre(instance.champs, instance.ecrans)) {
    ctx.addIssue({ code: z.ZodIssueCode.custom, message: faute, path: ['ecrans'] });
  }
});

/** Racine non stricte en lecture : une clef future n'empêche pas l'app de monter. */
export const instanceDocumentSchema = z.object({
  orgId: z.string().min(1),
  appId: z.string().min(1),
  schemaVersion: z.literal(INSTANCE_SCHEMA_VERSION),
  champs: appFieldsFileSchema,
  ecrans: appScreensFileSchema,
  fiche: ficheInstancieeSchema.optional(),
  modele: modeleSchema,
});
